import { useLogin } from "providers/Login";
import { normalizeRole, Role, ROLE_FULL_ADMIN, ROLE_POLICY_ADMIN } from "helpers/roles";

export interface RoleInfo {
    role: Role
    isFullAdmin: boolean
    //canEditPolicy is true for the roles that can change rules, applications,
    //data types, mask formats, obfuscations and alerts
    canEditPolicy: boolean
}

// NS-753
//useRole returns the dashboard role of the current user. Before the user is
//known it reports the lowest role.
export function useRole(): RoleInfo {
    const role = normalizeRole(useLogin().CurrentUser?.role);

    return {
        role,
        isFullAdmin: role === ROLE_FULL_ADMIN,
        canEditPolicy: role === ROLE_FULL_ADMIN || role === ROLE_POLICY_ADMIN,
    };
}
